/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChatMessageFeedback } from './ChatMessageFeedback';
import type { ChatMessageIssue } from './ChatMessageIssue';

export type ChatMessage = {
    id: string;
    threadId: string;
    role: ChatMessage.role;
    content: Record<string, any>;
    createdAt: string;
    updatedAt: string;
    feedback?: (ChatMessageFeedback | Record<string, any> | null);
    issues?: Array<ChatMessageIssue>;
};

export namespace ChatMessage {

    export enum role {
        USER = 'user',
        ASSISTANT = 'assistant',
        TOOL_CALL = 'tool_call',
    }


}

